var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 9.546C27.693 9.546 9.545 27.693 9.545 50S27.693 90.454 50 90.454 90.455 72.307 90.455 50 72.307 9.546 50 9.546Zm0 77.908c-20.652 0-37.455-16.802-37.455-37.454S29.348 12.546 50 12.546 87.455 29.348 87.455 50 70.653 87.454 50 87.454Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.271 68.031h-8.743V42.329a1.5 1.5 0 0 0-1.5-1.5H40.786a1.5 1.5 0 1 0 0 3h8.742v24.202h-8.742a1.5 1.5 0 1 0 0 3h20.485a1.5 1.5 0 1 0 0-3Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.029,
    cy: 30.449,
    r: 4.439
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationRound);
export default __webpack_public_path__ + "static/media/information-round.cd10f996db0b575282f78e7698371787.svg";
export { ForwardRef as ReactComponent };